import { defineMessages } from 'react-intl'

export default defineMessages({
    dataNotComplete: {
        id: 'containers.CustomerPage.Contacts.dataNotComplete',
        defaultMessage: 'Please complete customer data before creating a contact',
    }
})
